import * as React from 'react';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { Facet } from '../../../models/Facet';
import ColumnStrings from '../columns.resx';
import { SharedRenderer } from '../../fields/sharedItem/SharedRenderer';
import { ColumnWidth } from '../createColumn';

export const sharedColumn: IColumn = {
  key: new Facet('sharedColumn').id,
  name: ColumnStrings.Sharing,
  fieldName: '',
  minWidth: ColumnWidth.regularMin,
  maxWidth: ColumnWidth.sharedMax,
  isCollapsable: true,
  onRender: (item: {
    key: string;
  }, index?: number) => {
    return (
      <SharedRenderer itemKey={ item.key } />
    );
  }
};
